





















































































import {SelectKviCart} from '@/interfaces/global-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import {BModal} from 'bootstrap-vue';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';

@Component
export default class KviCartSelect extends Mixins(Toast, Http, LocalData) {
    removeModalVisible: boolean = false;
    hasActiveCalculationsModal: boolean = false;
    itemToRemove: SelectKviCart | null = null;
    deleteWithIndividual: boolean = false;
    addModalVisible: boolean = false;
    @Prop() readonly select_value!: SelectKviCart | null;
    @Prop() readonly selectTradingId!: number | null;
    @Prop({ default: null }) readonly storeFormatId!: number | null;
    @Prop({ default: () => [] }) readonly storeRegionIds!: number[];
    @Prop({ default: null }) readonly storeClusterId!: number | null;
    @Prop({ default: false }) readonly enableDownload!: boolean;

    selectValue: SelectKviCart = this.select_value ? this.select_value : {
        id: -1,
        kviCartName: this.$t('kviCarts.labels.selectCartFull') as string,
    };
    newKviCart: string | null = null;
    copyKviCartId: number | null = null;
    dropdownState: boolean = true;
    items: SelectKviCart[] = [];
    isChecked: boolean = false;
    downloadingCartIds: number[] = [];
    changeKviCartNameMap: Map<number, string> = new Map();
    emitName: string = '';

    mounted() {
      this.dropdownState = true;
      this.isChecked = this.selectValue.id !== -1;
      this.loadKviCarts();
    }

    eraseChoice() {
      this.selectValue = {
        id: -1,
        kviCartName: this.$t('kviCarts.labels.selectCartFull') as string,
      };
      this.isChecked = false;
      this.$emit(this.emitName, this.selectValue);
    }

    created() {
      this.emitName = Object.keys((this as any)._events)[0];

    }

    dropDownHide() {
      this.items.forEach((item) => {
                if (item.editable === false) {
                  const cartName = this.changeKviCartNameMap.get(item.id);
                  item.kviCartName = cartName ? cartName : '';
                  item.editable = true;
                }
              },
      );
    }

    clearKviCart() {
      this.newKviCart = '';
    }

    openAddKviCartModal() {
      this.addModalVisible = true;
    }

    handleAddOk(evt: Event) {
      evt.preventDefault();
      if (!this.newKviCart) {
        alert(this.$t('kviCarts.messages.enterName') as string);
      } else {
        this.addKviCart();
      }
    }

    handleCopyOk(evt: Event) {
      evt.preventDefault();
      if (!this.newKviCart) {
        alert(this.$t('kviCarts.messages.enterName') as string);
      } else {
        this.copyKviCart();
      }
    }

    loadKviCarts() {
      if (this.selectTradingId != null && this.selectTradingId !== -1) {
        this.httpLoadKviCartsByTradingId(this.selectTradingId)
                .then((json) => {
                  this.items = json.data
                          .map((item) => {
                            item.editable = true;
                            return item;
                          })
                          .sort((a, b) => {
                            return a.id === b.id ? 0 : +(a.id > b.id) || -1;
                          });
                  this.dropdownState = false;
                  this.$forceUpdate();
                })
                .catch(() => {
                  this.dropdownState = false;
                });
      } else {
        this.dropdownState = true;
      }
    }

    showRemoveModal(item: SelectKviCart) {
      this.itemToRemove = item;
      this.deleteWithIndividual = true;
      this.removeModalVisible = true;
    }

    handleRemoveCancel() {
      this.removeModalVisible = false;
      this.itemToRemove = null;
      this.deleteWithIndividual = false;
    }

    handleRemoveOk() {
      if (this.itemToRemove) {
        this.removeKviCart(this.itemToRemove.id, this.deleteWithIndividual);
        this.removeModalVisible = false;
        this.itemToRemove = null;
        this.deleteWithIndividual = false;
      }
    }

    handleHasActiveCalculationsOk() {
      this.hasActiveCalculationsModal = false;
    }

    copyHandler(cartId: number) {
        this.copyKviCartId = cartId;
    }

    private getFileNameFromDisposition(disposition?: string): string {
      if (!disposition) {
        return 'export.xlsx';
      }
      const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
      if (utf8Match && utf8Match[1]) {
        return decodeURIComponent(utf8Match[1]);
      }
      const simpleMatch = disposition.match(/filename="?([^";]+)"?/i);
      if (simpleMatch && simpleMatch[1]) {
        return simpleMatch[1];
      }
      return 'export.xlsx';
    }

    private getFilteredRegionIds(): number[] {
      return this.storeRegionIds.filter((id) => id > 0);
    }

    downloadKviCart(item: SelectKviCart) {
      if (!this.selectTradingId || this.selectTradingId <= 0 || this.downloadingCartIds.includes(item.id)) {
        return;
      }

      this.downloadingCartIds = [...this.downloadingCartIds, item.id];

      const params: {
        kviCartId: number;
        tradingId: number;
        userId: number;
        storeFormatId?: number;
        storeRegionId?: number[];
        storeClusterId?: number;
      } = {
        kviCartId: item.id,
        tradingId: this.selectTradingId,
        userId: this.$userId,
      };

      if (this.storeFormatId && this.storeFormatId > 0) {
        params.storeFormatId = this.storeFormatId;
      }

      const regionIds = this.getFilteredRegionIds();
      if (regionIds.length > 0) {
        params.storeRegionId = regionIds;
      }

      if (this.storeClusterId && this.storeClusterId > 0) {
        params.storeClusterId = this.storeClusterId;
      }

      this.httpExportKviCartProducts(params)
          .then((response) => {
            const disposition = response.headers['content-disposition'];
            const fileName = this.getFileNameFromDisposition(disposition);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            const status = error && error.response ? error.response.status : null;
            if (status === 403) {
              this.showError(this.$t('kviCarts.messages.exportNoAccess') as string);
              return;
            }
            if (status === 404) {
              this.showError(this.$t('kviCarts.messages.exportCartNotFound') as string);
              return;
            }
            this.showError(this.$t('kviCarts.messages.exportFailed') as string);
          })
          .finally(() => {
            this.downloadingCartIds = this.downloadingCartIds.filter((id) => id !== item.id);
          });
    }

    inputChangeListener(selectValue: SelectKviCart) {
      this.selectValue = selectValue;
      if (this.selectValue.id > 0) {
        this.isChecked = true;
      }
      this.$emit(this.emitName, this.selectValue);
      (this.$refs.dropdown as BModal).hide();
    }

    removeKviCart(cartId: number, withIndividualParams: boolean = false) {
      const tradingId = this.selectTradingId
      this.$http.delete('/api/kvi-carts/delete/id', {params: {kviCartId: cartId, deleteIndividualParams: withIndividualParams, tradingId: tradingId}})
          .then((json) => {
            this.$log.debug(json.data, this.selectValue);
            if (this.selectValue && this.itemToRemove && this.itemToRemove.kviCartName === this.selectValue.kviCartName) {
              this.selectValue = {id: -1, kviCartName: this.$t('kviCarts.labels.selectCartFull') as string};
              this.isChecked = false;
            }
            this.items = this.items
                .filter((item) => !this.itemToRemove || item.kviCartName !== this.itemToRemove.kviCartName)
                .sort((a, b) => {
                  return a.id === b.id ? 0 : +(a.id > b.id) || -1;
                });
            this.showInfo(this.$t('kviCarts.messages.successDeleted') as string);
            this.loadKviCarts();
          })
          .catch((err) => {
            if(err.response.status == 423)
            {
              this.hasActiveCalculationsModal = true;
            }
            this.$log.debug(err);
            this.showResponseError(err);
          });
    }

    addKviCart() {
      this.$http.post('/api/kvi-carts/add', null, { params: { kviCartName: this.newKviCart, tradingId: this.selectTradingId } })
              .then((json) => {
                this.$log.debug(json.data);
                const obj = json.data;
                obj.editable = true;
                this.items.push(obj);
                this.items = this.items.sort((a, b) => {
                  return a.id === b.id ? 0 : +(a.id > b.id) || -1;
                });
                this.$forceUpdate();
                this.showInfo(this.$t('kviCarts.messages.successAdded') as string);
                this.clearKviCart();
                this.addModalVisible = false;
              })
              .catch((err) => {
                this.$log.debug(err);
                this.showResponseError(err);
              });
    }

    copyKviCart() {
      const cartId = this.copyKviCartId
      this.$http.post('/api/kvi-carts/copy', null, {params: { kviCartId: cartId, kviCartName: this.newKviCart, tradingId: this.selectTradingId }})
          .then((json)=>{
            this.$log.debug(json.data);
            const obj = json.data;
            obj.editable = true;
            this.items.push(obj);
            this.items = this.items.sort((a, b) => {
              return a.id === b.id ? 0 : +(a.id > b.id) || -1;
            });
            this.$forceUpdate();
            this.showInfo(this.$t('kviCarts.messages.cartCopied') as string);
            this.clearKviCart();
            this.$bvModal.hide('copyKviCartModal')
          })
          .catch((err) => {
            this.$log.debug(err);
            this.showResponseError(err);
          });
    }

    @Watch('select_value')
    onChanged(newValue: SelectKviCart | null) {
      if (newValue == null) {
        this.selectValue = {
          id: -1,
          kviCartName: this.$t('kviCarts.labels.selectCartFull') as string,
        };
      } else {
        this.selectValue = newValue;
      }
    }
  }
